import { Coordinate } from "game-common/models"

/**
 * The non-visual half of a tree coming down: sound and the camera kick.
 *
 * The thing that knows WHEN is the fall itself (rendering/.../effects/tree_fall.ts), which is the only
 * thing watching the tree go over frame by frame; the Audio instance and the camera hang off
 * ClientGameLogic. They meet here, the same way the area projectile's moments do (see
 * area_projectile_feedback.ts), so neither imports the other.
 *
 * Nothing is installed in the unit-test harness, so every call is a no-op there unless a test installs
 * its own sink.
 */
export interface TreeFallFeedback {
    /** The hinge has given and the tree is going over, at the stump. */
    creaked: (at: Coordinate) => void
    /** It has hit the ground. `weight` is ~1 for a full-size tree coming down at full speed. */
    landed: (at: Coordinate, weight: number) => void
}

let installed: TreeFallFeedback | undefined

export const installTreeFallFeedback = (feedback?: TreeFallFeedback) => {
    installed = feedback
}

export const treeFallFeedback: TreeFallFeedback = {
    creaked: at => installed?.creaked(at),
    landed: (at, weight) => installed?.landed(at, weight),
}
